import { 
    SET_IMAGE_FOLDERS,
    LOADING_IMAGE,
    POST_IMAGE_FOLDER, 
    SET_IMAGE_FOLDER,
    CLEAR_IMAGE_SELECTED,
    MESSAGE_FROM_IMAGE,
    CLEAR_MESSAGE_IMAGE,
    SUBMIT_UPDATE_IMAGE,
    SELECT_IMAGE_FILE,
    DELETE_IMAGE_FILE,
 } from '../types';

const initialState = {
    image_forders: [],
    image_forder: {},
    image: {},
    image_index: null,
    loading: false,
    message: null,
    submit: false,
}

export default function(state = initialState, action) {
    switch(action.type){
        case LOADING_IMAGE:
            return {
                ...state,
                loading: true
            };
        case SET_IMAGE_FOLDERS:
            return {
                ...state,
                image_forders: action.payload,
                loading: false
            };
        case SET_IMAGE_FOLDER:
            return {
                ...state,
                image_forder: action.payload,
                loading: false
            }
        case POST_IMAGE_FOLDER:
            return {
                ...state,
                image_forders: [
                    action.payload,
                    ...state.image_forders
                ]
            }
        case CLEAR_IMAGE_SELECTED:
            return {
                image_forders: [],
                image_forder: {},
                image: {},
                image_index: null,
                loading: false,
                message: null,
                submit: false,
            }
        case SUBMIT_UPDATE_IMAGE:
                return {
                    ...state,
                    submit: true,
                }
        case MESSAGE_FROM_IMAGE:
            state.image_forder.image_files[action.index] = {
                ...state.image_forder.image_files[action.index],
                alt: action.data_image.alt,
                note: action.data_image.note,
            }
            state.image = {
                ...state.image,
                alt: action.data_image.alt,
                note: action.data_image.note,
            }
            return {
                ...state,
                message: action.payload,
                submit: false,
            }
        case DELETE_IMAGE_FILE:
            state.image_forder.image_files.splice(action.index, 1);
            return state
        case CLEAR_MESSAGE_IMAGE: 
            return {
                ...state,
                message: null,
            }
        case SELECT_IMAGE_FILE:
            return {
                ...state,
                image: action.payload,
                image_index: action.index,
            }
        default:
            return state;
    }
}